import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  DEFAULT_OG_IMAGE,
  DEFAULT_SEO,
  ROUTE_SEO,
  SITE_NAME,
  SITE_URL,
} from "../../seoConfig";

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const route = ROUTE_SEO[pathname] || DEFAULT_SEO;
    const title = route.title || DEFAULT_SEO.title;
    const description = route.description || DEFAULT_SEO.description;
    const keywords = route.keywords || DEFAULT_SEO.keywords;
    const canonical = `${SITE_URL}${pathname === "/" ? "/" : pathname}`;

    document.title = title;

    setMeta("description", description);
    setMeta("keywords", keywords);
    setMeta("copyright", "© 2026 StayHealthy. Built by Amina Javed. All rights reserved.");

    setLink("canonical", canonical);

    setMeta("og:type", "website", "property");
    setMeta("og:site_name", SITE_NAME, "property");
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:url", canonical, "property");
    setMeta("og:image", DEFAULT_OG_IMAGE, "property");
    setMeta("og:locale", "en_US", "property");

    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    setMeta("twitter:image", DEFAULT_OG_IMAGE);
  }, [pathname]);

  return null;
}
